<div class="relative item flex justify-center">
    <p
        class="relative z-10 text rounded-full"
        [class.text-white]="selected()"
        [attr.data-text]="textColor()"
        [class.bg-primary-50]="isToday() && !selected() && !has()"
    >
        {{ day()?.format("DD") }}
    </p>
    @if (has()) {
        <div class="absolute bg-primary/20 w-full inset-0"></div>
    } @else if (selected()) {
        <div
            [class.rounded-l-md]="isStart()"
            [class.rounded-r-md]="isEnd()"
            class="absolute bg-primary inset-0"
        ></div>
    }
</div>
